/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Security_Monitoring_DescInputs */

const es_privacy_policy_security_monitoring_desc = /** @type {(inputs: Privacy_Policy_Security_Monitoring_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registros de auditoria completos, monitoreo continuo de actividades sospechosas, escaneos regulares de vulnerabilidades y pruebas de penetracion.`)
};

const en_privacy_policy_security_monitoring_desc = /** @type {(inputs: Privacy_Policy_Security_Monitoring_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete audit logs, continuous monitoring of suspicious activities, regular vulnerability scans, and penetration testing.`)
};

/**
* | output |
* | --- |
* | "Complete audit logs, continuous monitoring of suspicious activities, regular vulnerability scans, and penetration testing." |
*
* @param {Privacy_Policy_Security_Monitoring_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_security_monitoring_desc = /** @type {((inputs?: Privacy_Policy_Security_Monitoring_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Security_Monitoring_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_security_monitoring_desc(inputs)
	return en_privacy_policy_security_monitoring_desc(inputs)
});
export { privacy_policy_security_monitoring_desc as "privacy_policy.security.monitoring_desc" }